import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreCollection, DocumentChangeAction } from '@angular/fire/compat/firestore';
import { colections, documentCodigoRegistro } from 'src/app/shared/cons/db.colections';
import { CodigoRegistro } from '../models/codigo-registro';
import { Utils } from 'src/app/shared/helpers/utils';
import { serverTimestamp } from 'firebase/firestore';
import { TransaccionModel } from 'src/app/shared/services/models/trasaccion.model';

@Injectable({
  providedIn: 'root'
})
export class CodigoRegistroDaService {
  transaccion: TransaccionModel = new TransaccionModel();
  constructor(
  private db: AngularFirestore
  ) { }

  async insertCodigo(codigo:CodigoRegistro){
    const externoCodigoRef =  this.db.collection(colections.EXTERNO_CODIGO_REGISTRO).doc();
    const docCodigo = Utils.SerializeJsonToDb(codigo);
    docCodigo.fecha_creacion = serverTimestamp();

    const correoExistente = await this.db.collection(colections.EXTERNO_CODIGO_REGISTRO, refx=>
      refx.where(documentCodigoRegistro.CORREO_ELECTRONICO,'==',codigo.correo_electronico)
      .where(documentCodigoRegistro.ES_VALIDO,'==',true)).get().toPromise();
    try{
      const txResult = this.db.firestore.runTransaction(async (transaccion) => {
        //invalidamos codigo anterior
        if(!correoExistente.empty){
          const refCodigoExistente = correoExistente.docs[0].ref;
          transaccion.update(refCodigoExistente,
            { 'es_valido':false,
              'usuario_actualizacion':codigo.usuario_creacion,
              'fecha_actualizacion':serverTimestamp()
            });
        }
        //insertamos nuevo codigo
        transaccion.set(externoCodigoRef.ref,docCodigo);
        
        this.transaccion = {
          tx: true,
        };
        return this.transaccion;
      });
      return txResult;
    }catch(error){
      this.transaccion.tx = false;
      this.transaccion.data = error;
      return this.transaccion;
    }
  }

  async getCodigoLectura(codigo:number, correoElectronico:string){    
    const result= await this.db.collection(colections.EXTERNO_CODIGO_REGISTRO, refx=>
      refx.where(documentCodigoRegistro.CORREO_ELECTRONICO,'==',correoElectronico)
      .where(documentCodigoRegistro.ES_VALIDO,'==',true)
      .where(documentCodigoRegistro.CODIGO_REGISTRO,'==',codigo)
      .limit(1)
    ).get().toPromise();
    let objCod: CodigoRegistro | null = null;
    if(!result.empty){
      const codigoValido = Utils.convertDate(result.docs[0].data()) as CodigoRegistro;
      codigoValido.id = result.docs[0].id;
      objCod = codigoValido;
      return objCod
    }
    else{
      return null;
    }

  }
  updateValidezCodigo(idCodigoRegistro:string){
    const refDod = this.db.collection(colections.EXTERNO_CODIGO_REGISTRO).doc(idCodigoRegistro);
    return refDod.update({'es_valido':false}).then(()=>{
      this.transaccion = {
        tx: true,
      };
      return this.transaccion;
    }).catch((error)=>{
      this.transaccion.tx = false;
      this.transaccion.data = error;
      return this.transaccion;
    })
  }
}
